module.exports = __webpack_public_path__ + "media/images/site/fundamental1_meninas-ab867e15f0cd2e724aadd4d8180f543d.jpg";